(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nd-gift-options"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nd-gift-options')) {
    customElements.define('nd-gift-options', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.packaging = this.querySelector('[data-packaging]');
        this.message = this.querySelector('[data-message]');
        this.panel = this.querySelector('[data-message-panel]');
        this.status = this.querySelector('[data-status]');
        this.retry = this.querySelector('[data-retry]');
        this.form = document.getElementById('cart');
        this.lockedPayments = new Map();
        this.saved = JSON.stringify(this.values());
        this.refresh();
        const options = { signal: this.controller.signal };
        this.packaging.addEventListener('change', () => {
          if (this.packaging.value !== 'Yes') this.message.value = '';
          this.refresh();
          this.changed();
        }, options);
        this.message.addEventListener('input', () => {
          this.refresh();
          this.changed();
        }, options);
        this.retry.addEventListener('click', () => this.flush(), options);
        this.form?.addEventListener('submit', (event) => this.beforeSubmit(event), { ...options, capture: true });
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (typeof event.cartData?.item_count === 'number') this.hidden = event.cartData.item_count === 0;
          });
        }
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.controller = null;
        this.unsubscribe?.();
        this.lockPayments(false);
        if (this.isDirty()) this.flush();
      }

      values() {
        return {
          'Gift packaging': this.packaging.value === 'Yes' ? 'Yes' : '',
          'Gift message': this.packaging.value === 'Yes' ? this.message.value : ''
        };
      }

      isDirty() {
        return JSON.stringify(this.values()) !== this.saved;
      }

      refresh() {
        const selected = this.packaging.value === 'Yes';
        this.panel.hidden = !selected;
        this.message.disabled = !selected;
        this.querySelector('[data-count]').textContent = `${this.message.value.length} / 300`;
      }

      lockPayments(locked) {
        if (locked && this.isConnected) {
          document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach((element) => {
            if (!this.lockedPayments.has(element)) this.lockedPayments.set(element, element.inert);
            element.inert = true;
          });
        } else {
          this.lockedPayments?.forEach((wasInert, element) => { element.inert = wasInert; });
          this.lockedPayments?.clear();
        }
      }

      changed() {
        clearTimeout(this.timer);
        this.removeAttribute('data-save-error');
        this.retry.hidden = true;
        this.status.textContent = this.dataset.saving;
        this.lockPayments(true);
        this.timer = setTimeout(() => this.flush(), 350);
      }

      flush() {
        clearTimeout(this.timer);
        if (this.savePromise) return this.savePromise;
        this.savePromise = (async () => {
          while (this.isDirty()) {
            const attributes = this.values();
            this.setAttribute('aria-busy', 'true');
            this.status.textContent = this.dataset.saving;
            const response = await fetch(this.dataset.updateUrl, {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ attributes })
            });
            if (!response.ok) throw new Error('Gift details could not be saved');
            const cart = await response.json();
            for (const [key, value] of Object.entries(attributes)) {
              if (String(cart.attributes?.[key] ?? '') !== value) throw new Error('Gift details were not confirmed');
            }
            this.saved = JSON.stringify(attributes);
          }
          this.removeAttribute('data-save-error');
          this.retry.hidden = true;
          this.status.textContent = this.packaging.value === 'Yes' ? this.dataset.saved : '';
          return true;
        })().catch(() => {
          this.setAttribute('data-save-error', '');
          this.status.textContent = this.dataset.error;
          this.retry.hidden = false;
          return false;
        }).finally(() => {
          this.removeAttribute('aria-busy');
          this.savePromise = null;
          this.lockPayments(this.isDirty());
        });
        return this.savePromise;
      }

      async beforeSubmit(event) {
        if (this.passingSubmit || (!this.isDirty() && !this.savePromise)) return;
        event.preventDefault();
        if (this.waitingSubmit) return;
        this.waitingSubmit = true;
        const submitter = event.submitter;
        const saved = await this.flush();
        this.waitingSubmit = false;
        if (!saved || !this.isConnected) return;
        this.passingSubmit = true;
        this.form.requestSubmit(submitter || undefined);
        this.passingSubmit = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
